module.exports = __webpack_public_path__ + "static/img/aff7.13337bf8.png";